// apis/waitresstipoutService.js
import authApiService from "./userApiService";

const handleError = (error) => {
  console.error('API Error:', error);
  return {
    success: false,
    error: error.response?.data?.error || error.message || 'An error occurred',
    statusCode: error.response?.status
  };
};

const handleSuccess = (response) => ({
  success: true,
  data: response.data,
  statusCode: response.status
});

export const waitresstipoutService = {
  async getBalances() {
    try {
      const response = await authApiService.get("/waitress-tips/balances");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getEmployees() {
    try {
      const response = await authApiService.get("/waitress-tips/employees");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getRecords(params = {}) {
    try {
      const response = await authApiService.get("/waitress-tips/records", { params });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getOverallTotals() {
    try {
      const response = await authApiService.get("/waitress-tips/overall-totals");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async addRecord(data) {
    try {
      const response = await authApiService.post("/waitress-tips/records", data);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async updateRecord(id, data) {
    try {
      const response = await authApiService.put(`/waitress-tips/records/${id}`, data);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async deleteRecord(id) {
    try {
      const response = await authApiService.delete(`/waitress-tips/records/${id}`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getActivityLogs(params = {}) {
    try {
      const response = await authApiService.get("/waitress-tips/activity-logs", { params });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async clearActivityLogs(payload = {}) {
    try {
      const response = await authApiService.delete("/waitress-tips/activity-logs", {
        data: payload,
      });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  }
};